import { TParamState } from 'shared/mf-infrastructure/types/params';
import { TApplicationState } from 'shared/mf-infrastructure/types/redux';

export function selectParams(state: TApplicationState): TParamState | null {
  return state.params;
}
